module.exports = __webpack_public_path__ + "img/drainage, irrigation.c119533d.jpg";